import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button, Callout, Checkbox } from '@node-space/ui-components'
import { BVNK_BLOG_FRAUD_PREVENTION } from 'constants/General'

const RequiredAppCallout = () => {
  const { t } = useTranslation()
  const [isChecked, setIsChecked] = useState(false)
  return (
    <>
      <Callout
        variant="info"
        GhostButton={
          <Button
            onClick={() => window.open(BVNK_BLOG_FRAUD_PREVENTION, '_blank', 'noopener,noreferrer')}
          >
            {t('howToPaySafelyMessage')}
          </Button>
        }
      >
        {t('authorisedPushPaymentsMessage')}
      </Callout>
      <Box paddingT={24} paddingB={8}>
        <Checkbox
          id="app-checkbox"
          name="app-checkbox"
          testId="app-checkbox"
          checked={isChecked}
          onCheckedChange={() => setIsChecked(current => !current)}
          label={t('authorisedPushPaymentsConfirmationMessage')}
        >
          <a
            href={BVNK_BLOG_FRAUD_PREVENTION}
            className="hover:underline text-xs text-foreground-action-secondary"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('learnMore')}
          </a>
        </Checkbox>
      </Box>
    </>
  )
}

export default RequiredAppCallout
